<template>
  <div
    class="modal inmodal in"
    tabindex="-1"
    :style="display"
    @click="closeModal">

    <div class="modal-dialog">
      <div class="modal-content animated fadeIn">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" @click="closeModal">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">
              Close
            </span>
          </button>
          <i class="fa fa-eraser modal-icon"></i>
          <h4 class="modal-title">Remover Registro</h4>
          <small></small>
        </div>

        <div class="modal-body">
          <p><strong>Você está prestes a remover um registro do sistema.</strong></p>
          <p>O registro será removido permanentemente.</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-white"
            data-dismiss="modal"
            @click="closeModal">
            Cancelar
          </button>

          <button type="button" class="btn btn-danger" @click="confirmAction">Confirmar exclusão</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    display () {
      return this.show ? 'display: block' : 'display: none'
    }
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
    confirmAction() {
      this.$emit('confirm')
    }
  }
}
</script>